export default __webpack_public_path__ + "static/media/jiaoshima-bg.a279b6fc.png";